import { useEntityName } from './hooks';

/**
 * The root breadcrumb's text for a document opened from an entity page: the
 * entity's name, or the fallback while it loads or if it can't load.
 * @param {object} props The label.
 * @param {string} props.href The entity page, e.g. /entities/1564.
 * @param {string} props.fallback Text shown until (or unless) the name loads.
 * @return {JSX.Element} The label.
 */
export function EntityCrumbLabel({
  href,
  fallback,
}: {
  href: string;
  fallback: string;
}) {
  const { data: name } = useEntityName(href);
  return <>{name || fallback}</>;
}
